import React, { useRef, useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CameraCapture({ onCapture }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [stream, setStream] = useState(null);

  // Mulai kamera setelah elemen video siap
  useEffect(() => {
    const startCamera = async () => {
      try {
        const newStream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        if (videoRef.current) {
          videoRef.current.srcObject = newStream;
          setStream(newStream);
          setIsCameraOn(true);
        } else {
          console.warn("videoRef belum siap");
        }
      } catch (err) {
        console.error("Gagal mengakses kamera:", err);
        toast.error(
          "Gagal mengakses kamera. Pastikan izin kamera diizinkan dan gunakan http://localhost (atau https)."
        );
      }
    };

    // Jalankan setelah delay kecil agar elemen sudah mount
    const timer = setTimeout(startCamera, 300);
    return () => {
      clearTimeout(timer);
      if (stream) stream.getTracks().forEach((t) => t.stop());
    };
    // eslint-disable-next-line
  }, []);

  const handleCapture = () => {
    if (!videoRef.current || !canvasRef.current) return;
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const dataUrl = canvas.toDataURL("image/png");
    if (onCapture) onCapture(dataUrl);
  };

  const stopCamera = () => {
    if (videoRef.current?.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((t) => t.stop());
      videoRef.current.srcObject = null;
    }
    // Kosongkan frame terakhir (hapus tampilan beku)
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute("src");
      videoRef.current.load();
    }
    setIsCameraOn(false);
  };

  return (
    <div className="text-center">
      <video
        ref={videoRef}
        autoPlay
        playsInline
        style={{
          width: "100%",
          maxWidth: "480px",
          borderRadius: "10px",
          background: "#000",
        }}
      />
      <canvas ref={canvasRef} style={{ display: "none" }} />

      {isCameraOn && (
        <div className="mt-3 d-flex justify-content-center gap-2">
          <Button variant="primary" onClick={handleCapture}>
            📸 Ambil Foto
          </Button>
          {/* <Button variant="secondary" onClick={stopCamera}>
            ❌ Tutup Kamera
          </Button> */}
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default CameraCapture;
